import styled from "styled-components";
import {JackpotBetWinHighlightDefaultBox} from "./jackpot-bet-win-highlight.default.box";

export const JackpotBetWinHighlightMRGreenBox = styled(JackpotBetWinHighlightDefaultBox)`
    box-shadow: 
        0px 0px 20px 0px #B1E1C580 inset,
        0px 0px 30px 2px #B1E1C5BF,
        0px 0px 40px 0px #01FF9166 inset;

    background-color: #22004d; 
    background-image: radial-gradient( #293835 20%, #00120E 50%);

    border: 2px solid #B1E1C5;
`;


